/*
 * Topics Views
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/topicsSplit/topics/template/topicsTemplate.html",
  "i18n/i18n",
  "bootstrap",
  "jquery-ui",
  "jquery-ui/ui/widgets/droppable",
], function (Marionette, $, Messenger, TopicsTemplate) {
  "use strict";

  const TopicsView = {};

  TopicsView.topicsLayout = Marionette.Layout.extend({
    template: TopicsTemplate,
    events: {
      "show #archivedTopicsTab": function (e) {
        this.$el.find("#snippets").addClass("hidden");
        this.$el.find("#standardResponses").addClass("hidden");
        this.$el.find("#variablePrompts").addClass("hidden");
        this.trigger("show:archived:topics", e);
      },
      "show #navigationTab": function (e) {
        this.$el.find("#snippets").removeClass("hidden");
        this.$el.find("#standardResponses").removeClass("hidden");
        this.$el.find("#variablePrompts").removeClass("hidden");
        this.trigger("show:navigation:topics", e);
      },
      "show #searchTab": function (e) {
        this.trigger("show:search:topics", e);
      },
    },
    onRender: function () {
      this.$el.i18n();
      this.$el
        .find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]')
        .tooltip({ delay: { show: 333, hide: 0 }, container: "body" });
      //set droppable target for the add new topic plus sign
      const _this = this;
      const kbId = Messenger.reqres.request("active:kb");
      const canCreateTopic = Messenger.reqres.request("can:create:topic", kbId);
      if (canCreateTopic) {
        //support for dropping learner examples into the example area
        this.$el.find("#addTopic").droppable({
          addClasses: false,
          activeClass: "droppable-active",
          hoverClass: "droppable-hover",
          tolerance: "pointer",
          drop: function () {
            _this.trigger("dropped:transcript");
          },
        });
      } else {
        this.$el.find("#addTopic").hide();
      }
    },
    regions: {
      topicsTree: "#topicsTree",
      topicsList: "#topicsList",
      searchPane: "#searchPane",
      snippetsTree: "#snippetsTree",
    },
    collapseTopicsTree: function () {
      this.$el.find("#topicsTree").addClass("collapsed");
    },
    collapseSnippetsTree: function () {
      this.$el.find("#snippetsTree").addClass("collapsed");
    },
    collapseTopicsTreeAndShowSnippetsTree: function () {
      this.$el.find("#topicsTree").addClass("collapsed");
      this.$el.find("#snippetsTree").removeClass("collapsed");
    },
    expandTopicsTreeAndCollapseSnippetsTree: function () {
      this.$el.find("#topicsTree").removeClass("collapsed");
      this.$el.find("#snippetsTree").addClass("collapsed");
    },
    selectSnippets: function () {
      this.$el.find("#snippets").addClass("bold");
    },
    selectStandardResponse: function () {
      this.$el.find("#standardResponses").addClass("bold");
    },
    selectVariablePrompts: function () {
      this.$el.find("#variablePrompts").addClass("bold");
    },
    triggers: {
      "click #addTopic": "add:topic",
      "click #snippets": "show:snippets",
      "click #standardResponses": "show:standard:responses",
      "click #variablePrompts": "show:variable:prompts",
    },
    unselectSnippets: function () {
      this.$el.find("#snippets").removeClass("bold");
    },
    unselectStandardResponse: function () {
      this.$el.find("#standardResponses").removeClass("bold");
    },
    unselectVariablePrompts: function () {
      this.$el.find("#variablePrompts").removeClass("bold");
    },
  });

  return TopicsView;
});
